import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {AlertService, ResolvePlanService} from "../_services";
import {PlanListAbstractComponent} from "./plan-list-abstract.component";

@Component({
  moduleId: module.id.toString(),
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.css']
})
export class ResolvePlanComponent extends PlanListAbstractComponent {
  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected planService: ResolvePlanService,
    protected alertService: AlertService,
  ) {
    super(router, location, route, planService, alertService);
    this.objectName = 'resolve_plan';
    this.title = 'Resolve Plans';
    this.routePrefix = 'resolve-plan';
    this.planLabel = 'Resolve Plan';
  }
}
